// Preset widths for the Public View "Screen size" preview control - fed
// straight into App.js's viewport-meta effect via ThemeContext's
// previewWidth. 0 is "off" (plain device-width, the normal mobile layout);
// 480 ("Large Mobile") is a step up for larger phones/phablets; 768
// deliberately sits in the tablet breakpoint band (see useIsWideViewport.js).
// Desktop (1920) and Laptop (1024) were dropped at the user's request - 480
// reuses Mobile's own icon (no separate phone-size glyph exists) rather than
// go without one.
export const RESOLUTION_PRESETS = [
    { width: 0, label: "Mobile", icon: "smartphone" },
    { width: 480, label: "Large Mobile", icon: "smartphone" },
    { width: 768, label: "Tablet", icon: "tablet" },
];

// 0 (off) always stays available so an active preview can be turned back
// off regardless of device width; every other preset only qualifies if it's
// a genuine step up from the real device the visitor is actually on - a
// device already at/above the widest preset (768) is left with only the off
// entry, which callers read as "hide the control entirely" (nothing left to
// preview up to).
export const getAvailableResolutionPresets = (deviceWidth) =>
    RESOLUTION_PRESETS.filter(preset => preset.width === 0 || preset.width > deviceWidth);
